import './App.css';
import { CircularProgress, Paper, Typography } from "@mui/material";
import logo from './Images/chitaj_logo_dark_long.png'
import Index from './Components/Index/Index';
import {
  createBrowserRouter,
  Link,
  RouterProvider,
} from "react-router-dom";
import Contribute from './Components/Contribute/Contribute';
import FullSummaryView from './Components/Pages/FullSummaryView';
import { getClientUrl } from './env';
import About from './Components/Pages/About';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "/contribute",
    element: <Contribute />,
  },
  {
    path: "/item/:id",
    element: <FullSummaryView />,
  },
  {
    path: "/about",
    element: <About />,
  },
]);


function App() {
  return (
    <div className="App">
      <Paper style={{ width: '100%', padding: '3px 0', marginBottom: '20px', backgroundColor: '#1B2430', height: '100px', borderRadius: 0 }}>
        <a href={getClientUrl()}>
          <img src={logo} alt='logo' height={80}></img>
        </a>
      </Paper>
      <RouterProvider router={router} />
    </div>
  );
}
export default App;